import axios from "axios";

export const fetchProfilePicture = async (bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_PROFILE_PICTURE,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
